import { ButtonLink, MailIcon, PhoneIcon, Stack } from '@fukuri-admins/ui/common';
import styles from './styles.module.scss';

type Props = {
  /** HubSpot のお問い合わせフォームへの遷移 URL（パートナーコード付き） */
  contactFormUrl: string;
};

/**
 * お問い合わせ手段 Presentation
 *
 * フォーム / 電話の 2 つの問い合わせ手段をカードで横並びに表示する。
 * フォームは HubSpot の外部フォームのため、別タブで開く。
 */
export const ContactMethodsPresentation: React.FC<Props> = ({ contactFormUrl }) => (
  <Stack direction='column' gap={24}>
    <p className={styles.description}>
      福利厚生アプリをご利用いただき、ありがとうございます。機能や使い方についてご不明な点がございましたら、以下の連絡先にお問い合わせください。専任のサポートチームが、より快適にお使いいただけるようサポートいたします。
    </p>
    <Stack direction='row' gap={24}>
      <section className={styles.card}>
        <h2 className={styles.cardTitle}>
          <MailIcon aria-hidden />
          フォームでのお問い合わせ
        </h2>
        <p className={styles.cardDescription}>内容を確認のうえ、担当者より順次ご返信いたします。</p>
        <Stack direction='row'>
          <ButtonLink to={contactFormUrl} isExternal target='_blank'>
            問い合わせる
          </ButtonLink>
        </Stack>
      </section>
      <section className={styles.card}>
        <h2 className={styles.cardTitle}>
          <PhoneIcon aria-hidden />
          お電話でのお問い合わせ
        </h2>
        <Stack direction='column' gap={8}>
          <p className={styles.phoneNumber}>03-4405-7151</p>
          <p className={styles.receptionTime}>受付時間：平日10:00〜18:00</p>
        </Stack>
      </section>
    </Stack>
  </Stack>
);
